<template>
  <div class="custom-page-box">
    <a-card title="素材空间" :bordered="false">
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'MaterialSpace',
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style lang="less">
@import "../CustomPage";
</style>